import React from 'react';

function CompleteHemogramForm() {
  return (
    <div>
      <h2>CompleteHemogramForm</h2>
    </div>
  );
}

export default CompleteHemogramForm;
